import api from './axios.config';

export class MetadataApi {
  static async getAllBrands() {
    return api.get(`/Metadata/allbrands`).then((res) => res.data);
  }
}
